export default "__VITE_ASSET__BE84nrKL__"